<template>
  <div :class="[$style['com-weekly-sub-panel']]">
    <h2>订阅</h2>
    <div :class="[$style.weekly]">每周精要</div>
    <div :class="[$style.line]"></div>
    <div :class="[$style['will-get']]">
      <div :class="[$style.label]">你将获得</div>
      <slot name="link">
        <a href="https://www.infoq.cn/weekly/landing" target="_blank">
          了解详情
          <i :class="['iconfont', $style.iconfont]">&#xe62f;</i>
        </a>
      </slot>
    </div>
    <ul>
      <li>资深编辑编译的全球 IT 要闻</li>
      <li>一线技术专家撰写的实操技术案例</li>
      <li>InfoQ 出品的课程和线下活动报名通道</li>
    </ul>
    <SubModule />
  </div>
</template>
<script>
import SubModule from './Sub'
export default {
  name: 'com-weekly-sub',
  components: {
    SubModule
  },
  props: {
  },
  data () {
    return {
    }
  },
  methods: {
    toWeeklyLanding () {
      // this.$router.push('/weekly/landing')
      window.open('https://www.infoq.cn/weekly/landing')
    }
  }
}
</script>
<style lang="scss" module>
@import "../../assets/css/_common";
.com-weekly-sub-panel {
  box-sizing: border-box;
  position: relative;
  width: 100%;
  padding: 29px 20px 26px 21px;
  background: #ffffff url('../../assets/img/left-bottom.png') no-repeat left bottom / 108px 101px;
  border: 1px solid $borderGray; border-radius: 3px;
  
  &:before {
    content: "";
    position: absolute; z-index: 10; top: 0; right: 0;
    width: 139px; height: 99px;
    background: url('../../assets/img/top-right.png') no-repeat left bottom / 139px 99px;
  }

  & h2 {
    @include lineFont(23, 500);
    color: $lightBlack;
  }

  & .weekly {
    padding-left: 74px; margin: 13px 0 23px;
    background: url('../../assets/img/logo-infoq.png') no-repeat left bottom / 64px 20px;
    @include lineFont(23, 500);
    color: $lightBlack;
  }

  & .line {
    width: 100%; height: 1px;
    margin: 23px auto 20px;
    border-top: 1px solid $borderGray;
    opacity: 0.4;
  }

  & .will-get {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;

    & a {
      @include lineFont(14, 500);
      color: #09aca8;

      &:hover {
        color: #25C2BE;
      }
    }
  }

  & i.iconfont {
    margin-left: -4px;
    font-size: 14px!important;
  }

  & .label {
    width: 110px; height: 32px;
    margin-left: -21px;
    background: #f8f9fa;
    border-radius: 0 32px 32px 0;
    line-height: 32px;
    text-align: center;
    @include font(16, 400);
    color: $lightBlack;
  }

  & ul {
    margin-bottom: 14px;
    list-style: none;

    li {
      position: relative;
      padding-left: 12px; margin-bottom: 12px;
      @include lineFont(14, 400);
      color: $gray;

      &:before {
        content: "";
        position: absolute; z-index: 1; top: 4px; left: 0px;
        width: 0; height: 0;
        border: 2px solid; border-radius: 50%;
      }
    }

    & li:nth-child(1):before {
      border-color: $lightGreen;
    }

    & li:nth-child(2):before {
      border-color: #c6a3ce;
    }

    & li:nth-child(3):before {
      border-color: #387be6;
    }
  }
}
</style>
